export const OFFSET_SCROLL = 190;
export const SCROLL_SPEED = 1000;
export const SENTRY_DSN =
  'https://c8ebfff9837a4e67a9a94c1863d38d97@o463608.ingest.sentry.io/5469074';
export const VUESCROLLTO_OPTIONS = {
  duration: 400,
  easing: 'ease',
  force: false,
  offset: -180,
};

export const ORGANIC_FARMING_ID = 83;
export const SUSTAINABILITY_PAGE_ID = 43569;
